import { ButtonToolbar, Group } from '@salecycle/ui-component-library';
import * as React from 'react';

export const AppTopBarButtons: React.FC = () => {
  return (
    <Group>
      <ButtonToolbar dividerRight={false} />
    </Group>
  );
};
